export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-pricetag-multiple-b09f09cb6e71831946ad26cb787bf8fa.svg";